export const defaultProfileRouteSearchState = (): ProfileRouteSearchState<'user'> => ({
  sort: {
    sortType: 'user',
    sortOrder: 'ascending'
  }
});
